export default __webpack_public_path__ + "static/media/White0000.08e35a49.png";